import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./icons";
import "antd/dist/antd.less";
import "./style/base.less";
import "lib-flexible";
import Playground from "./Playground";
import { addPerform } from "./tools/perform-tool";
import { Provider } from "react-redux";
import store from "./store/index";
const root = ReactDOM.createRoot(document.getElementById("root"));
addPerform({ name: "page.index.start   " });

root.render(
  // <React.StrictMode>
  // <Provider store={store}>
  //   <Playground />
  // </Provider>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
